import { render, staticRenderFns } from "./notice-component.vue?vue&type=template&id=0d601e67&scoped=true&"
import script from "./notice-component.vue?vue&type=script&lang=js&"
export * from "./notice-component.vue?vue&type=script&lang=js&"
import style0 from "./notice-component.vue?vue&type=style&index=0&id=0d601e67&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d601e67",
  null
  
)

export default component.exports